import { useNgCasinoGameList } from "@allwyn/casino/js/core/ng-casino-game-list";
import { useNgCasino } from "@allwyn/casino/js/core/use-ng-casino";
import { useNg } from "@allwyn/ng/ng-integration";
// import { useLottery3DSRedirection } from "@/lotteries/utils/use-lottery-3ds-redirection";
import { ngOpenPage } from "./ng-open-page";

export const useNgLib = async () => {
    await useNg(ngOpenPage);
    await useNgCasino().initializeNgCasino();
    await useNgCasinoGameList().initializeGameList();
    // await useLottery3DSRedirection();
};
